import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DownloaderComponent } from './components/downloader/downloader.component';
import { ReportComponent } from './components/results/report/report.component';
import { InformationComponent } from './components/results/information/information.component';
import { ResultComponent } from './components/results/result/result.component';
import { SignatureComponent } from './components/results/signature/signature.component';
import { UploadComponent } from './components/upload/upload.component';
import { VerificationRoutingModule } from './verification-routing.module';
import { TimestampComponent } from './components/results/timestamp/timestamp.component';
import { VerificationService } from './services/verification.service';
import { VerificationSession } from './services/verification-session.service';
import { SharedModule } from '../shared/shared.module';
import { VerificationRedirectionService } from './guards/verification-redirection.service';
import { MatIconModule } from '@angular/material/icon';
import { VerificationComponent } from './components/verification/verification.component';
import { FieldsetComponent } from './components/fieldset/fieldset.component';
import { UploaderV2Component } from './components/uploader-v2/uploader-v2.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { XsrfInterceptor } from 'src/app/Interceptors/xsrf.interceptor';
import { MomentDatePipe } from 'src/app/models/moment-date.pipe';

@NgModule({
  declarations: [UploadComponent,
    InformationComponent,
    SignatureComponent,
    ResultComponent,
    MomentDatePipe,
    DownloaderComponent,
    ReportComponent,
    TimestampComponent,
    VerificationComponent,
    UploaderV2Component,
    FieldsetComponent],
  exports: [
    DownloaderComponent,
    UploadComponent,
  ],
  imports: [
    CommonModule,
    VerificationRoutingModule,
    FormsModule,
    NgbModule,
    FontAwesomeModule,
    SharedModule,
    MatIconModule
  ],
  providers: [
    VerificationService,
    VerificationSession,
    VerificationRedirectionService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: XsrfInterceptor, multi: true,
    }
  ]
})
export class VerificationModule {
}
